// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1-eE5","large":"styles_large__1yRVo"};